import { useTranslations } from '@npco/utils-translations'
import {
  Box,
  Flex,
  MagnifyingGlassNoResults,
  MessageSize,
  MessageWithIcon,
} from '@npco/zeller-design-system'
import { Copy } from 'features/Invoicing/components/Invoices/InvoiceTable/NoInvoicesFound/NoInvoicesFound.styled'

import { translations } from './NoInvoicesFound.i18n'

export const NoInvoicesFound = () => {
  const t = useTranslations(translations)
  return (
    <Flex flexDirection="column" flexGrow="1" justifyContent="center">
      <MessageWithIcon
        align="center"
        description={
          <Box textAlign="center">
            <Copy>{t('copy')}</Copy>
          </Box>
        }
        image={<MagnifyingGlassNoResults size="large" />}
        size={MessageSize.LARGE}
        title={<Box textAlign="center">{t('header')}</Box>}
      />
    </Flex>
  )
}
